import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[auiHeaderLogo]',
})
export class HeaderLogoDirective {
}
